export const WITNESSES_ACTIONS = {
    GET_ALL: 'WITNESSES_GET_ALL',
    GET_ACTIVE: 'WITNESSES_GET_ACTIVE',
    FIND: 'WITNESSES_FIND',
    CHANGE_STATUS: 'WITNESSES_CHANGE_STATUS',
    DELETE: 'WITNESSES_DELETE',
    SUCCESS: 'WITNESSES_SUCCESS',
    ERROR: 'WITNESSES_ERROR',
    CLEAN: 'WITNESSES_CLEAN',
    RESET: 'WITNESSES_RESET',
}